module.exports = ".noResult {\n  width: 100%;\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/apac-detail/detail/detail.component.scss
// module id = ./src/app/modules/apac-detail/detail/detail.component.scss
// module chunks = main